import { FormatModule } from "tabulator-tables";
import clickIsOutsideElementBounds from "@root/services/clickIsOutsideElementBounds";

const { image: imageFormatter } = FormatModule.formatters;

export default function (cell, formatterParams, onRendered) {
  const value = cell.getValue();

  if (!value) {
    return '';
  }

  const { image, route } = value;

  const container = document.createElement('div');
  container.classList.add('w-100', 'h-100', 'd-flex', 'align-items-center', 'justify-content-center');
  const _cell = {
    ...cell,
    getValue() {
      return image;
    },
    getRow() {
      return cell.getRow()
    },
  };

  const imgThumbnail = imageFormatter.call(this, _cell, formatterParams, onRendered);

  const modal = document.createElement('dialog');
  modal.style.width = '80%';
  modal.style.height = '80%';
  modal.addEventListener('click', event => {
    if (clickIsOutsideElementBounds(modal, event)) {
      event.stopPropagation();
      modal.close();
    }
  })

  const iframe = document.createElement('iframe');
  iframe.style.width = '100%';
  iframe.style.height = '100%';
  iframe.src = route;

  modal.appendChild(iframe);

  imgThumbnail.style.cursor = 'pointer';
  imgThumbnail.addEventListener('error', imgThumbnail.remove);
  imgThumbnail.addEventListener('load', () => cell.getTable().redraw);

  imgThumbnail.addEventListener("click", function (e) {
    e.stopPropagation();
    !modal.open && modal.showModal();
  });

  imgThumbnail.classList.add('img-fluid');

  container.appendChild(imgThumbnail);
  container.appendChild(modal);

  return container;
}
